module.exports = __webpack_public_path__ + "img/como-evitar-burnout.6ce36e8f.svg";